<template>
  <v-tooltip bottom>
    <template #activator="{ on, attrs }">
      <v-btn
        icon
        v-on="on"
        v-bind="attrs"
        :small="small"
        color="error"
        @click="deletePlan"
      >
        <v-icon v-text="'$delete'"></v-icon>
      </v-btn>
    </template>
    {{ $t('assemblyPlanningDover.deletePlan') }}
  </v-tooltip>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'DeletePlan',
  props: {
    planId: {
      type: String,
      required: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
    listType: {
      type: String,
      default: 'all',
    },
  },
  methods: {
    ...mapActions('assemblyPlanningDover', ['deletePlanByPlanId']),
    async deletePlan() {
      if (await this.$root.$confirm.open(
        this.$t('assemblyPlanningDover.confirmDeleteTitle'),
        this.$t('assemblyPlanningDover.confirmDeleteSubtitle', { id: this.planId }),
      )) {
        const deleted = await this.deletePlanByPlanId({
          planId: this.planId,
          listType: this.listType,
        });
        if (this.$route.name === 'assemblyPlanDetailsDover' && deleted) {
          this.$router.go(-1);
        }
      }
    },
  },
};
</script>
